import React, { useMemo } from 'react';

import Blockquote from '@tiptap/extension-blockquote';
import Link from '@tiptap/extension-link';
import { Placeholder } from '@tiptap/extension-placeholder';
import StarterKit from '@tiptap/starter-kit';
import { Markdown } from 'tiptap-markdown';

import { makeStyles } from '@gogame/ui/styles';

import { RichTextFormControl } from './components/RichTextFormControl';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '170px',
    overflow: 'auto',
  },
}));

export const MarkdownRichText = ({
  name,
  label,
  value,
  error,
  autofocus,
  placeholder,
  onChange,
  helperText,
  showToolbar = true,
}) => {
  const classes = useStyles();
  const extensions = useMemo(() => {
    let result = [StarterKit, Link, Blockquote, Markdown];
    if (placeholder) {
      result.push(
        Placeholder.configure({
          placeholder: placeholder,
        })
      );
      return result;
    }
  }, [placeholder]);

  const handleUpdateEditor = ({ onChange: inputOnChange, editor }) => {
    const markdownOutput = editor.storage.markdown.getMarkdown();
    inputOnChange({ target: { value: markdownOutput } }, markdownOutput);
  };

  return (
    <RichTextFormControl
      value={value}
      onChange={onChange}
      name={name}
      label={label}
      error={error}
      helperText={helperText}
      extensions={extensions}
      showToolbar={showToolbar}
      autofocus={autofocus}
      onUpdateEditorCallback={handleUpdateEditor}
      className={classes.root}
    />
  );
};
